import React, { FC } from 'react';
import styles from './tabField.module.scss';
import { TabOptionT } from "../../../../models/models";
import Label from "../Label/Label";
import { Span } from "../../../Text/Text";
import ErrorText from "../ErrorText/ErrorText";

type TabFieldPropTypes = {
    options: TabOptionT[];
    name: string;
    label: string;
    register: any;
    orderIndex: number;
    errorMessage: string;
    style: any;
    onChange: (value: any) => void;
    defaultValue: number;
    extraContent: any;
};

/**
 * Tabs based on radio buttons
 * */

const TabField: FC<TabFieldPropTypes> = (props) => {
    const {
        options,
        name,
        label,
        register,
        orderIndex,
        errorMessage,
        style,
        onChange,
        defaultValue,
        extraContent,
    } = props;

    return (
        <div key={name} style={{ order: orderIndex, ...style }}>
            <Label name={name} label={label}>
                <ul className={styles.wrapper}>
                    {options.map(({ value, label }, index) => (
                        <li key={value}>
                            <label className={styles.radio}>
                                <input
                                    type="radio"
                                    value={value}
                                    {...register(name as `${string}`)}
                                    // set to checked if it is the first element
                                    defaultChecked={index === defaultValue}
                                    onChange={() => onChange(value)}
                                />
                                <Span>{label}</Span>
                            </label>
                        </li>
                    ))}
                </ul>
            </Label>
            <ErrorText text={errorMessage} />
            {!!extraContent && extraContent()}
        </div>
    );
};

export default TabField;